// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .card {\n    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n  }\n", ""]);
// Exports
module.exports = exports;
